import { render, staticRenderFns } from "./home.vue?vue&type=template&id=5a3a581a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/home.css?vue&type=style&index=0&id=5a3a581a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a581a",
  null
  
)

export default component.exports